export const hasRequiredPendingUserNames = (user) =>
	!!(user?.firstName?.trim() && user?.lastName?.trim());

export const formatPendingUserDateTime = (utc) => {
	if (!utc) return '—';

	const date = new Date(utc);
	if (Number.isNaN(date.getTime())) return utc;

	return date.toLocaleString(undefined, {
		dateStyle: 'medium',
		timeStyle: 'short',
	});
};

export const getPendingUserDisplayName = (user) => {
	const fullName = `${user?.firstName || ''} ${user?.lastName || ''}`.trim();
	return fullName || user?.email || '';
};

export const getPendingApprovalDetailsItems = (principal) => [
	{
		id: 'waiting-since',
		name: 'Waiting since',
		value: formatPendingUserDateTime(principal?.firstSeenUtc),
	},
	{
		id: 'last-synced',
		name: 'Last synced',
		value: formatPendingUserDateTime(principal?.lastSeenUtc),
	},
];

export const buildSalesforcePendingSyncDialogState = ({
	title,
	severity,
	messages = [],
}) => ({
	title,
	severity,
	messages,
	failures: [],
});

export const buildSalesforcePendingSyncPerformanceWarningMessages = (pendingCount = 0) => {
	const count = Number(pendingCount) || 0;
	const queueMessage = count > 0
		? `There ${count === 1 ? 'is currently 1 user' : `are currently ${count} users`} in the waiting room.`
		: 'This will scan all pending Salesforce leads.';

	return [
		queueMessage,
		'Sync scans every pending Salesforce lead and reconciles the entire waiting room. Large queues can take a while and may briefly slow Salesforce lookups.',
		'Continue only if you need a full refresh of the Pending Approval list.',
	];
};

export const buildSalesforcePendingSyncSummaryMessages = (result) => {
	const discoveredCount = result?.discoveredCount ?? 0;
	const reconciledCount = result?.reconciledCount ?? 0;
	const approvedAndNotifiedCount = result?.approvedAndNotifiedCount ?? 0;
	const removedCount = result?.removedCount ?? 0;
	const pendingCount = result?.pendingCount ?? 0;

	return [
		`Discovered ${discoveredCount} pending lead(s).`,
		`Reconciled ${reconciledCount} waiting-room row(s).`,
		`Approved and notified ${approvedAndNotifiedCount} user(s).`,
		`Removed ${removedCount} row(s).`,
		`${pendingCount} user(s) remain in the waiting room.`,
	];
};
